import * as React from "react";
import {
  Button,
  Caption1,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
  makeStyles,
  shorthands,
  Text,
  tokens,
} from "@fluentui/react-components";
import { Icon } from "@iconify/react";
import { t } from "../../utils/translations";

import { aes256CbcDecrypt } from "../../utils/encryption";
import forge from "node-forge";

const useStyles = makeStyles({
  card: {
    width: "400px",
    maxWidth: "100%",
    height: "fit-content",
  },
  caption: {
    color: tokens.colorNeutralForeground3,
  },
  grayBackground: {
    backgroundColor: tokens.colorNeutralBackground3,
  },
  logoBadge: {
    ...shorthands.padding("5px"),
    ...shorthands.borderRadius(tokens.borderRadiusSmall),
    backgroundColor: "#FFF",
    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)",
  },
  cardPreview: {
    ...shorthands.padding("10px"),
    backgroundColor: tokens.colorNeutralBackground3,
  },
});

export const FirmaCard = ({ signature, onSelect, selected }) => {
  const styles = useStyles();
  const [decryptedSignature, setDecryptedSignature] = React.useState(signature);

  React.useEffect(() => {
    if (signature.isEncrypted) {
      const key = forge.util.decode64(signature.key);
      const iv = forge.util.decode64(signature.iv);
      setDecryptedSignature({
        ...signature,
        file: aes256CbcDecrypt(signature.file, key, iv),
        background_meeting: signature.background_meeting ? aes256CbcDecrypt(signature.background_meeting, key, iv) : "",
        background_preview: signature.background_preview ? aes256CbcDecrypt(signature.background_preview, key, iv) : "",
        isEncrypted: false,
      });
    }
  }, [signature]);

  const handlePreviewClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;
    if (target.tagName === "A" || target.closest("a")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <Card className={styles.card} onClick={(e) => onSelect(e, decryptedSignature)} selected={selected}>
      <CardHeader header={<Text weight="semibold">{decryptedSignature.name}</Text>} />
      <CardPreview className={styles.cardPreview}>
        <div dangerouslySetInnerHTML={{ __html: decryptedSignature.file }} onClick={handlePreviewClick} />
      </CardPreview>
      <CardFooter>
        {selected && (
          <>
            <Icon icon="fluent-mdl2:accept-medium" />
            <Caption1 className={styles.caption}>{t("selectedSignature")}</Caption1>
          </>
        )}
        {!selected && <Button onClick={(e) => onSelect(e, decryptedSignature)}>{t("selectSignature")}</Button>}
      </CardFooter>
    </Card>
  );
};
